export const PUBLISH_API_REQUEST = "PUBLISH_API_REQUEST";
export const PUBLISH_API_SUCCESS = "PUBLISH_API_SUCCESS";
export const PUBLISH_API_ERROR = "PUBLISH_API_ERROR";
export const PUBLISH_CLEAN_RESULT = "PUBLISH_CLEAN_RESULT";
